module.exports = __webpack_public_path__ + "img/icon-kmg-rumah.95869c1a.svg";